import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import FlatButton from 'material-ui/FlatButton'
import Snackbar from 'material-ui/Snackbar'
import { FormattedMessage } from 'react-intl'

export default class Form extends Component {
  state = {
    email: '',
    open: false,
    snackbarMessage: ''
  }

  handleRequestClose = () => this.setState({open: false})
  getSnackbarDetails = message => {
    this.setState({
      open: true,
      snackbarMessage: message
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    const {email} = this.state
    const {id, registerEmail} = this.props
    if (email.length !== 0) {
      registerEmail(email, id).then(res => {
        if (res.status && res.status === 'success') {
          if (res.data.register_msg === 'already registered') {
            this.getSnackbarDetails(
              <FormattedMessage id="registration.emailRegistered"/>
            )
          } else if (res.data.register_msg === 'no account') {
            this.getSnackbarDetails(
              <FormattedMessage id="registration.noAccount"/>
            )
          } else if (res.data.register_msg === 'account exists') {
            this.getSnackbarDetails(
              <FormattedMessage id="registration.accountExists"/>
            )
          }
        }
      })
      this.setState({email: ''})
    }
  }

  render () {
    return (
      <form className="flex justify-center mt4" onSubmit={this.handleSubmit}>
        <div style={{width: '30vw'}} className="flex">
          <div className="w-70 bg-white">
            <TextField
              hintStyle={{
                color: 'rgba(107, 124, 147, 0.7)'
              }}
              type="email"
              style={{paddingLeft: 10, paddingRight: 10}}
              fullWidth
              value={this.state.email}
              onChange={e =>
                this.setState({email: e.target.value, open: false})}
              underlineShow={false}
              hintText={<FormattedMessage id="login.emailLable"/>}
            />
          </div>
          <FlatButton
            type="submit"
            disabled={this.props.isRequestingRegisteration}
            className="w-50 h-100-important"
            backgroundColor="#FCCE42"
            hoverColor="#BFAB6D"
            labelStyle={{color: '#8B7124'}}
            label={<FormattedMessage id="seminar.registration"/>}
            style={{height: 42}}
          />
        </div>
        {false && <Snackbar
          style={{
            left: 300,
            bottom: 30,
            pointerEvents: 'none',
            whiteSpace: 'nowrap'
          }}
          bodyStyle={{pointerEvents: 'initial', maxWidth: 'none'}}
          open={this.state.open}
          message={this.state.snackbarMessage}
          action={<FormattedMessage id="seminarActions.dismiss"/>}
          onActionTouchTap={this.handleRequestClose}
          autoHideDuration={10000}
          onRequestClose={this.handleRequestClose}
        />}
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Registration/Form.js